<template>
 <div style="position:relative;" class="search-form">
  <vue-typed-js :strings="['Labradorite','Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces', 'Peace of Mind', 'Mercury','Venus','Earth','Mars','Jupiter','Saturn','Uranus','Neptune','Pluto','Sun','Moon','Sun','Water','Earth','Fire','Wind','Storm','Air', 'Third Eye', 'Manifestation','Strength','Serenity','Stress Relief','Digestive Health','Ambition','Justice','Attraction','Personal Will']" :attr="'placeholder'" :loop="true" :shuffle="true" v-if="typed">
    <input type="text" :class="custom_class" id="search-input" v-model="query" v-on:keyup="autoComplete" aria-describedby="emailHelp" placeholder="" @focus="focused = true" @blur="focused = false">
  </vue-typed-js>
  <input type="text" :class="custom_class" id="search-input" v-model="query" v-on:keyup="autoComplete" aria-describedby="emailHelp" placeholder="Search" v-if="!typed" @focus="focused = true"  @blur="focused = false">
  <div class="panel-footer mt-2" v-show="mouseOver || (focused && query.length > 0)" @mouseover="mouseOver = true" @mouseout="mouseOver = false">
   <div class="list-group" id="list-group-results">
    <li v-if="loading" class="list-group-item list-group-item-action text-dark">
      <i class="fas fa-spinner fa-spin mr-1"></i>Loading
    </li>
    <div class="list-group-item m-0 p-0" v-for="(result_group,type) in results">
      <div class="row m-0">
        <div class="col-4 col-sm-3 search-type bg-light py-2">
          <b style="color:#737373">{{ type.replace(/_/g, ' ') | capitalize }}</b>
        </div>
        <div class="col-8 col-sm-9">
          <div class="row">
            <a :href="result.slug" class="text-dark col-12 py-2 result-row" v-for="result in result_group">
              <img v-if="result.image" :src="result.image" class="rounded-circle mr-2" style="width:30px;height:30px;"/>
              <b>{{ result.title }}</b>
            </a>
          </div>
        </div>
      </div>
    </div>
    <a href="#" class="list-group-item list-group-item-action text-dark" v-if="no_results">
      No results found
    </a>

   </div>
  </div>
 </div>
</template>
<script>
 export default{
  props: {
      typed: false,
      mobile: false,
      custom_class: {
        type: String,
        default: 'py-3 py-md-2 form-control typing',
      }
  },
  data(){
   return {
    query: '',
    loading: false,
    selected: 0,
    focused: false,
    mouseOver: false,
    no_results: false,
    prev_query: null,
    results: []
   }
  },
  http: {
    root: '/root',
    headers: {
        'X-CSRF-Token': Laravel.csrfToken
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  created () {

  },
  watch: {
    selected: function (val) {
      $("#list-group-results>a.active").removeClass("active");
      $( "#list-group-results>a:nth-child(" + val + ")" ).addClass('active');
    }
  },
  methods: {
   autoComplete(event){
    if(event.keyCode == 13 && this.query.length > 0)
    {
      window.location.href = "/search/" + this.query;
    }
    //DOWN
    else if(event.keyCode == 40)
    {
      if(this.results.length > 0)
      {
        if(this.selected >= this.results.length)
          this.selected = 1;
        else
          this.selected++;
      }
    }
    else if(event.keyCode == 38)
    {
      if(this.results.length > 0)
      {
        if(this.selected <= 1)
          this.selected = this.results.length;
        else
          this.selected--;
      }
    }
    else if(event.keyCode == 13) {
      if(this.selected > 0)
      {
        window.location.href = $( "#list-group-results>a:nth-child(" + this.selected + ")" ).attr('href');
      }
    }
    else if(this.prev_query !== this.query)
    {
      this.results = [];
      this.selected = 0;
      this.no_results = false;
      if(this.query.length > 1){
        this.prev_query = this.query;
        this.loading = true;
        var $data = {
            'query':     this.query
        };
        ga('send', 'pageview', '/ajax/search?q=' + this.query);
        this.$http.post('/ajax/search?q=' + $data.query, $data).then(response => {
          this.loading=false;
          this.results = response.data.results;

         if(this.results < 1)
         {
          this.no_results = true;
         }
         else
         {
          this.no_results = false;
         }
        }, response => {
          // error callback
        });
      }
    }//End Else
   }
  }
 };
</script>